import { render, staticRenderFns } from "./ReviewQuote.vue?vue&type=template&id=2c6c70c1&lang=pug"
import script from "./ReviewQuote.vue?vue&type=script&lang=js"
export * from "./ReviewQuote.vue?vue&type=script&lang=js"
import style0 from "./ReviewQuote.vue?vue&type=style&index=0&id=2c6c70c1&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports